if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductCoupons);
} else {
    initProductCoupons();
}

document.addEventListener('shopify:section:load', initProductCoupons);
document.addEventListener('shopify:block:load', initProductCoupons);

function initProductCoupons() {
    const customCartCoupons = window.customCartCoupons || [];
    
    // Find the Best Price container
    const bestPriceContainer = document.querySelector('.best-price-box-wrapper[data-product-id]');
    // Find the Offers container
    const offersContainer = document.querySelector('.offers-block-section-wrapper[data-product-id]');

    if (!bestPriceContainer && !offersContainer) return;

    let productId, productPrice, productCollectionsRaw;
    if (bestPriceContainer) {
        productId = parseInt(bestPriceContainer.getAttribute('data-product-id'));
        productPrice = parseInt(bestPriceContainer.getAttribute('data-product-price'));
        productCollectionsRaw = bestPriceContainer.getAttribute('data-product-collections');
    } else if (offersContainer) {
        productId = parseInt(offersContainer.getAttribute('data-product-id'));
        productPrice = parseInt(offersContainer.getAttribute('data-product-price'));
        productCollectionsRaw = offersContainer.getAttribute('data-product-collections');
    }

    const collectionIds = (productCollectionsRaw || "").split(',').filter(x => x).map(id => parseInt(id.trim()));

    // Evaluate all coupons to find which ones are eligible for this product
    const eligibleCoupons = [];
    const nonEligibleCoupons = [];
    let bestCoupon = null;
    let maxSavings = 0;

    customCartCoupons.forEach(coupon => {
        if (coupon.applyTo && coupon.applyTo !== 'both' && coupon.applyTo !== 'product') return;

        const hasInclusions = (coupon.productIds && coupon.productIds.length > 0) || 
                              (coupon.collectionIds && coupon.collectionIds.length > 0);
        const hasExclusions = (coupon.excludeProductIds && coupon.excludeProductIds.length > 0) || 
                              (coupon.excludeCollectionIds && coupon.excludeCollectionIds.length > 0);
        
        // 1. Check Exclusions FIRST
        let isExcluded = false;
        if (hasExclusions) {
            if (coupon.excludeProductIds && coupon.excludeProductIds.includes(productId)) {
                isExcluded = true;
            } else if (coupon.excludeCollectionIds && coupon.excludeCollectionIds.some(id => collectionIds.includes(id))) {
                isExcluded = true;
            }
        }
        
        if (isExcluded) { nonEligibleCoupons.push(coupon); return; }

        // 2. Check Inclusions
        let isIncluded = true;
        if (hasInclusions) {
            isIncluded = false;
            if (coupon.productIds && coupon.productIds.includes(productId)) {
                isIncluded = true;
            } else if (coupon.collectionIds && coupon.collectionIds.some(id => collectionIds.includes(id))) {
                isIncluded = true;
            }
        }

        if (!isIncluded) { nonEligibleCoupons.push(coupon); }

        if (isIncluded) {
            // It's eligible!
            eligibleCoupons.push(coupon);

            // Calculate savings
            let savings = 0;
            if (coupon.type === 'percentage') {
                savings = Math.round(productPrice * (coupon.value / 100));
            } else if (coupon.type === 'fixed') {
                savings = coupon.value;
            }

            // Note: best-price logic on product page doesn't typically enforce cart minPurchase to show the badge, 
            // but we can enforce it if product price < minPurchase and it's a fixed discount.
            if (savings > maxSavings) {
                maxSavings = savings;
                bestCoupon = coupon;
            }
        }
    });

    // --- Render Best Price ---
    if (bestPriceContainer) {
        if (bestCoupon && maxSavings > 0) {
            const templateEl = document.getElementById(bestPriceContainer.id.replace('Best-Price', 'BestPriceTemplate'));
            if (templateEl) {
                const bestPriceFinal = Math.max(0, productPrice - maxSavings);
                let html = templateEl.innerHTML;
                
                // Format money without trailing zeros if they are zeros. Assuming INR style for simplicity.
                const formatNum = (cents) => {
                    const rupees = cents / 100;
                    return '₹' + rupees.toLocaleString('en-IN', { maximumFractionDigits: 0 });
                };

                html = html.replace(/{best_price}/g, formatNum(bestPriceFinal))
                           .replace(/{saved_amount}/g, formatNum(maxSavings))
                           .replace(/{coupon_code}/g, bestCoupon.code);

                bestPriceContainer.querySelector('.best-price-main-box').innerHTML = html;
                bestPriceContainer.style.display = 'block';
                bestPriceContainer.classList.remove('hidden');
            }
        }
    }

    // --- Render Offers Block ---
    if (offersContainer && (eligibleCoupons.length > 0 || nonEligibleCoupons.length > 0)) {
        const templateEl = document.getElementById(offersContainer.id.replace('offers-container', 'OfferCardTemplate'));
        if (templateEl) {
            let cardsHtml = '';
            
            eligibleCoupons.forEach(coupon => {
                let tabText = '';
                let savingsText = '';
                let title = coupon.desc || 'Special Offer';
                
                if (coupon.type === 'percentage') {
                    tabText = coupon.value + '% OFF';
                    let discountAmount = Math.round(productPrice * (coupon.value / 100));
                    savingsText = 'Save ₹' + (discountAmount / 100) + ' on this order';
                } else {
                    tabText = '₹' + (coupon.value / 100) + ' OFF';
                    savingsText = 'Save ₹' + (coupon.value / 100) + ' on this order';
                }

                let cardHtml = templateEl.innerHTML;
                cardHtml = cardHtml.replace(/{tab_text}/g, tabText)
                                   .replace(/{savings_text}/g, savingsText)
                                   .replace(/{code}/g, coupon.code)
                                   .replace(/{desc}/g, coupon.desc || 'Click to copy code')
                                   .replace(/{discount_color}/g, '#0a8a5b'); // Use default green or extract from settings

                cardsHtml += cardHtml;
            });

            let moreCardsHtml = '';
            if (nonEligibleCoupons.length > 0) {
                nonEligibleCoupons.forEach(coupon => {
                    let tabText = '';
                    let savingsText = 'Not applicable to this product';
                    
                    if (coupon.type === 'percentage') {
                        tabText = coupon.value + '% OFF';
                    } else {
                        tabText = '?' + (coupon.value / 100) + ' OFF';
                    }

                    let cardHtml = templateEl.innerHTML;
                    cardHtml = cardHtml.replace(/{tab_text}/g, tabText)
                                       .replace(/{savings_text}/g, savingsText)
                                       .replace(/{code}/g, coupon.code)
                                       .replace(/{desc}/g, coupon.desc || 'Click to copy code')
                                       .replace(/{discount_color}/g, '#9ca3af');

                    moreCardsHtml += cardHtml;
                });
            }

            const carousel = offersContainer.querySelector('.offers-carousel');
            if (carousel) carousel.innerHTML = cardsHtml + moreCardsHtml;
            
            // Inject into modal
            const modalId = offersContainer.id.replace('offers-container', 'offers-modal');
            const modal = document.getElementById(modalId);
            if (modal) {
                const modalGrid = modal.querySelector('.offers-modal-grid');
                if (modalGrid) {
                    let finalHtml = cardsHtml;
                    if (moreCardsHtml !== '') {
                        finalHtml += '<div style="font-weight: 700; font-size: 14px; color: #333; margin-top: 20px; margin-bottom: 10px; width: 100%;">More offers</div>' + moreCardsHtml;
                    }
                    modalGrid.innerHTML = finalHtml;
                }
            }

            offersContainer.style.display = 'block';
            offersContainer.classList.remove('hidden');
            
            // Handle View All link logic
            const viewAllBtn = offersContainer.querySelector('.offers-view-all');
            if (viewAllBtn) {
                if (eligibleCoupons.length + nonEligibleCoupons.length > 1) {
                    viewAllBtn.style.display = 'flex';
                } else {
                    viewAllBtn.style.display = 'none';
                }
            }
            
            // Re-bind modal events if needed
            if (typeof window.initOffersBlock === 'function') {
                window.initOffersBlock();
            }
        }
    } else if (offersContainer) {
        // No offers, hide block
        offersContainer.style.display = 'none';
    }
}

console.log('Product coupons script loaded', window.customCartCoupons);

